import { track } from './analyticsService.js'

const CLICK = 'Click'

export const trackButtonClicked = (buttonName, customProperties = null) => (
  track(CLICK, { button_name: buttonName, ...customProperties })
)
